// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Tooltip, { TooltipPresentationProps } from "@flip/MobiusOverrides/Tooltip/Tooltip";
import { mergeWithCss } from "@flip/XDL/Utilities";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Typography } from "@insite/mobius/index";
import { TypographyProps } from "@insite/mobius/Typography";
import React, { FC, useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product?: ProductModel;
    cartLine?: CartLineModel;
    extendedStyles?: TypographyProps;
}

const ProductMinimumOrderQtyStyles: TypographyProps = {
    css: css`
        margin-bottom: 12px;
    `,
};

const toolTipStyles: TooltipPresentationProps = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 5px;
            margin-right: 5px;
            margin-top: -5px;
        `,
    },
};

const ProductMinimumOrderQty: FC<OwnProps> = ({ product, cartLine, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(ProductMinimumOrderQtyStyles, extendedStyles));
    const minimumOrderQty = product?.minimumOrderQty || cartLine?.properties.minimumOrderQty || 0;

    if (parseInt(minimumOrderQty as string, 10) <= 1) {
        return null;
    }

    return (
        <Typography variant="legend" data-test-selector="minimum-ordered-quantity" {...styles}>
            {translate("MOQ")}: {minimumOrderQty}
            <Tooltip
                text={siteMessage("FLIP_Product_MOQ")}
                iconProps={{ size: 11 }}
                placement="top"
                {...toolTipStyles}
            />
        </Typography>
    );
};

export default ProductMinimumOrderQty;
